import {
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Breadcrumb as UiBreadcrumb,
} from '@/components/ui/breadcrumb'
import {
  Breadcrumb as BreadcrumbProps,
  useBreadcrumbs,
} from '@/hooks/breadcrumbs'
import { Fragment, useEffect } from 'react'
import { Link } from 'react-router'
import Paper from './Paper'

export default function Breadcrumbs() {
  // Hooks
  const { breadcrumbs } = useBreadcrumbs()

  // Computed
  const isLast = (index: number) => index === breadcrumbs.length - 1

  // Hide if there is just a single breadcrumb (the home link)
  if (breadcrumbs.length <= 1) return null

  return (
    <Paper className="p-4">
      <UiBreadcrumb>
        <BreadcrumbList>
          {breadcrumbs.map(({ label, path }, index) => (
            <Fragment key={index}>
              <BreadcrumbItem key={index}>
                {isLast(index) ? (
                  <BreadcrumbPage>{label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={path}>{label}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {!isLast(index) && <BreadcrumbSeparator />}
            </Fragment>
          ))}
        </BreadcrumbList>
      </UiBreadcrumb>
    </Paper>
  )
}

export function Breadcrumb({ label, path }: BreadcrumbProps) {
  const { push } = useBreadcrumbs()
  useEffect(() => push({ label, path }), [label, path, push])

  return null
}
